import { useTranslation } from 'react-i18next';
import { Link, useNavigate } from 'react-router';
import { ChangePasswordForm } from '../components/ChangePasswordForm';
import { LanguageSelector } from '../components/LanguageSelector';
import { useAuthStore } from '@/stores/authStore';
import { useAuth } from '../hooks/useAuth';
import { landingPath } from '@/lib/landing';

export function ChangePasswordPage() {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const role = useAuthStore((state) => state.user?.role);
  const { logoutMutation } = useAuth();

  // Forced first-login flow: redirect to the caller's landing page afterwards (the
  // "Mijn gegevens" ChangePasswordCard, h12-3, intentionally passes no onSuccess and stays
  // on the page instead).
  const handleSuccess = () => navigate(landingPath(role));

  return (
    <div
      data-testid="change-password-page"
      className="flex min-h-screen flex-col items-center justify-center p-12"
      style={{ backgroundColor: 'var(--background)' }}
    >
      <div className="absolute right-6 top-6">
        <LanguageSelector />
      </div>

      <div className="w-full max-w-[360px]">
        <h1
          data-testid="change-password-title"
          className="mb-1"
          style={{
            fontSize: '1.375rem',
            fontWeight: 700,
            letterSpacing: '-0.02em',
            color: 'var(--foreground-heading)',
          }}
        >
          {t('auth.changePasswordTitle')}
        </h1>
        <p
          data-testid="change-password-subtitle"
          className="mb-7"
          style={{ fontSize: '0.8125rem', color: 'var(--foreground-muted)' }}
        >
          {t('auth.changePasswordSubtitle')}
        </p>

        <ChangePasswordForm onSuccess={handleSuccess} />

        {/*
          Zonder deze twee zit iemand die zijn huidige wachtwoord kwijt is op dit scherm vast:
          de bovenbalk met de uitlogknop hangt achter dezelfde bewaking die hem hierheen stuurde.
        */}
        <div className="mt-6 flex items-center justify-between">
          <Link
            to="/reset-password"
            data-testid="change-password-forgot-link"
            className="text-xs font-medium"
            style={{ color: 'var(--secondary)' }}
          >
            {t('auth.forgotPassword')}
          </Link>
          <button
            type="button"
            onClick={() => logoutMutation.mutate()}
            data-testid="change-password-logout"
            className="text-xs font-medium"
            style={{ color: 'var(--foreground-muted)' }}
          >
            {t('auth.logout')}
          </button>
        </div>
      </div>
    </div>
  );
}
